import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeadline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHeadline"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H8.5V4.5H6.5V11.25H17.5V4.5H15.5V3H21V4.5H19V19.5H21V21H15.5V19.5H17.5V12.75H6.5V19.5H8.5V21H3V19.5H5V4.5H3V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHeadline;
